import React from 'react';

import CalendlyDialog from './CalendlyDialog';
import { DEFAULT_REQUEST_DEMO_CALENDLY_URL } from '../../lib/calendly';

export default function RequestDemoDialog({
  open,
  onOpenChange,
  title = 'Request a Demo',
  description = 'Pick a time that works for you.',
  iframeTitle = 'Calendly booking',
  src = DEFAULT_REQUEST_DEMO_CALENDLY_URL,
}) {
  return (
    <CalendlyDialog
      open={open}
      onOpenChange={onOpenChange}
      title={title}
      description={description}
      iframeTitle={iframeTitle}
      src={src}
    />
  );
}
